/**
 * The join key a regional fact is partitioned by.
 *
 * At landskap grain this is the region's name slug (`stockholm`, `skane`, ...); at kommun
 * grain it is the kommunkod. Which form a value carries is decided by the grain the
 * aggregation was built for, so the brand deliberately carries no format rule -- only the
 * guarantee that the value came from a feed the ACL decoded, or from
 * `regionFromGeoJsonFeature`, the one sanctioned place a region name becomes a RegionId.
 */
declare const __regionIdBrand: unique symbol;
export type RegionId = string & { readonly [__regionIdBrand]: never };

/**
 * Boundary parser for a region key read off a feed. Any non-empty value is a region key;
 * an empty one is a contract violation the caller reports and skips.
 */
export function tryRegionId(raw: string): RegionId | null {
  const normalized = raw.trim();
  return normalized.length > 0 ? (normalized as RegionId) : null;
}
